import { inject, Injectable, signal } from '@angular/core';
import { TSubMenu, ESubMenuType } from './main-navigation.interface';
import { Observable, of, tap } from 'rxjs';
import { QsHttpService } from 'src/app/core/http/qs-http.service';
import { IDataPayloadMultiple } from 'src/app/core/http/http.interface';

@Injectable({
  providedIn: 'root'
})
export class MainNavigationService {
  protected readonly _qsHttpService: QsHttpService = inject(QsHttpService);

  navigation$ = signal<IDataPayloadMultiple<TSubMenu> | null>(null);
  mainMenuState$ = signal<boolean>(false);
  subMenuState$ = signal<ESubMenuType | null>(null);

  toggleMainMenu(isOpen: boolean): void {
    this.mainMenuState$.set(!isOpen);
  }

  toggleSubNav(type: ESubMenuType | null): void {
    if (this.subMenuState$() === type) {
      this.subMenuState$.set(null);
      return;
    }

    this.subMenuState$.set(type)
  }

  getNavigation(): Observable<IDataPayloadMultiple<TSubMenu>> {
    const params = [
      'ctas',
    ];

    if (this.navigation$()) {
      return of(this.navigation$()!);
    }

    return this._qsHttpService.get<IDataPayloadMultiple<TSubMenu>>(`/navigations?populate=${params.join('&')}`)
      .pipe(
        tap((response) => {
          response.data = response.data?.sort((a, b) => a.attributes.order - b.attributes.order);
          this.navigation$.set(response);
        }),
      );
  }
}
